import TrackReport from 'yux-track-report'
import { setCookie, getCookie } from '@share/utils/index'
import { ALL_SITES, getCookieDomainByHost } from '@share/common/siteConfig'
type TrackOption = {
  cname: string
  path: string
  server: string
  logName: string
}

// 矩阵站允许的主域名集合（去掉前导 `.`），模块顶层一次性构建以避免重复计算
const MATRIX_DOMAIN_SET = new Set(
  ALL_SITES.map((s) => s.cookieDomain.replace(/^\./, '')).filter(Boolean),
)

const isInternalRefererHost = (url: string): boolean => {
  if (!url) return false
  try {
    const h = new URL(url).hostname.toLowerCase()
    for (const d of MATRIX_DOMAIN_SET) {
      if (h === d || h.endsWith(`.${d}`)) return true
    }
    return false
  } catch {
    return false
  }
}
// const getNewReportUrl = (server: string, logName: string): string => {
//   return `https://${
//     import.meta.env.VITE_ENV_TYPE === 'pro'
//       ? 'unitelogreport'
//       : 'ptunitelogreport'
//   }.reader.qq.com/enhanceLogger?app=QD&server=${server}&logName=${logName}&lines=`
// }
const getSEOReferer = (): void => {
  let trafficUtmReferer = getCookie('traffic_utm_referer') || ''
  // 矩阵站：referer 命中"自家站点"时（host 命中 *_sites_config 中任一域），不写入 cookie
  if (document.referrer && !isInternalRefererHost(document.referrer)) {
    trafficUtmReferer =
      new URL(document.referrer).origin + new URL(document.referrer).pathname
  }
  const timeDiff =
    new Date(new Date().toLocaleDateString()).getTime() +
    24 * 60 * 60 * 1000 -
    1 -
    new Date().getTime()

  // 当前矩阵站 cookieDomain（动态获取）
  const cookieDomain = getCookieDomainByHost()

  setCookie(
    'traffic_utm_referer',
    trafficUtmReferer
      ? new URL(trafficUtmReferer).origin + new URL(trafficUtmReferer).pathname
      : '',
    cookieDomain,
    '/',
    timeDiff,
  )
}
const getSEOEngine = (): void => {
  // seo信息 traffic_search_engine
  const trafficSearchEngine = getCookie('traffic_search_engine')
  const cookieDomain = getCookieDomainByHost()
  if (!trafficSearchEngine && document.referrer) {
    const curHost = new URL(document.referrer).hostname
    let curSearchEngine = ''
    if (/(\.baidu|cache\.baiducontent|mbaiducom\.bceapp)\.com$/.test(curHost)) {
      curSearchEngine = 'baidu'
    } else if (/(\.google\.|webcache\.googleusercontent\.com)/.test(curHost)) {
      curSearchEngine = 'google'
    } else if (/(sogou|soso|sogoucdn)\.com$/.test(curHost)) {
      curSearchEngine = 'sougou'
    } else if (/quark\.sm\.cn$/.test(curHost)) {
      curSearchEngine = 'quark'
    } else if (/sm\.cn$/.test(curHost)) {
      curSearchEngine = 'sm'
    } else if (/\.yahoo\.com$/.test(curHost)) {
      curSearchEngine = 'yahoo'
    } else if (/(nativeapp|m|so)\.toutiao\.com$/.test(curHost)) {
      curSearchEngine = 'toutiao'
    } else if (/(360webcache|so|haosou)\.com$/.test(curHost)) {
      curSearchEngine = '360'
    } else if (/bing\.com$/.test(curHost)) {
      curSearchEngine = 'bing'
    }
    // 会话cookie
    setCookie(
      'traffic_search_engine',
      curSearchEngine,
      cookieDomain,
      '/',
      1000 * 60 * 60 * 24 * 7,
    )
  }
  setCookie('se_ref', getCookie('traffic_search_engine'), cookieDomain, '/')
}
const track = (appId: string, options: TrackOption): TrackReport => {
  const pid = document.getElementById('app')?.getAttribute('data-pid') || ''
  const oldReportUrl = `/qreport`
  const { cname, path } = options
  //   const { cname, path, server, logName } = options
  return new TrackReport(appId, {
    reportUrl: oldReportUrl,
    debug: import.meta.env.VITE_ENV_TYPE !== 'pro',
    useRetainPreviousEvent: true,
    saveLocalRetainPEKeys: ['e1', 'e2'],
    employRetainPEDataKeys: ['eid', 'pid', /l[1-9]/],
    onLoad: (instance: TrackReport) => {
      getSEOReferer()
      getSEOEngine()
      const customProperties = {
        app: 'QD',
        cname,
        path,
        isQD: true,
        sw: screen.width,
        sh: screen.height,
        url: location.href,
        ref: document.referrer,
        title: document.title,
        traffic_utm_referer: getCookie('traffic_utm_referer'),
      }
      instance.setEventCustomProperties(customProperties, true)
    },
    autoTR: true,
    autoParamHook: (target: Element, eventType: string) => {
      let eid = ''
      let l1 = ''
      if (eventType === 'exposure') {
        eid = target?.getAttribute('data-showeid') || ''
        l1 = target?.getAttribute('data-showl1') || ''
      } else {
        eid = target?.getAttribute('data-eid') || ''
        l1 = target?.getAttribute('data-l1') || ''
      }
      const params = {
        pid,
        ltype:
          target?.getAttribute('data-ltype') || eventType === 'click'
            ? 'A'
            : 'H',
        eid,
        type: target?.getAttribute('data-type') || '',
        l1,
        l2: target?.getAttribute('data-l2') || '',
        l3: target?.getAttribute('data-l3') || '',
        l4: target?.getAttribute('data-l4') || '',
        l5: target?.getAttribute('data-l5') || '',
        l6: target?.getAttribute('data-l6') || '',
        l7: target?.getAttribute('data-l7') || '',
        bid: target?.getAttribute('data-bid') || '',
        cid: target?.getAttribute('data-cid') || '',
        auid: target?.getAttribute('data-auid') || '',
        tid: target?.getAttribute('data-tid') || '',
        rid: target?.getAttribute('data-rid') || '',
        kw: target?.getAttribute('data-kw') || '',
        is_daoliu: target?.getAttribute('data-is_daoliu') || '',
        testid: target?.getAttribute('data-testid') || '',
        bookstatus: target?.getAttribute('data-bookstatus') || '',
        param: target?.getAttribute('data-param') || '',
        qd_dd_p1:
          target?.getAttribute('data-qd_dd_p1') === '1'
            ? (target as HTMLAnchorElement)?.href
            : '',
      }
      return params
    },
    onBeforeSend: (data: Record<string, string | number>) => {
      if (data.ltype !== 'P' && data.ltype !== 't' && !data.eid) {
        return true
      }
      //   const leftBrackets = '[%27'
      //   const rightBrackets = '%27]'
      const linesArray = Object.keys(data).map((k: string) => {
        return `${k}=${encodeURIComponent(`${data[k]}&`)}`
      })
      const paramsInCookieArr = [
        'qduid',
        'stat_gid',
        'stat_sessid',
        'muniqUUID',
        'ywguid',
        'newstatisticUUID',
        'se_ref',
        'se_ref_bid',
      ]
      paramsInCookieArr.forEach((key) => {
        const value = getCookie(key)
        if (value) {
          linesArray.push(`${key}=${encodeURIComponent(`${value}&`)}`)
        }
      })
      linesArray.push(
        `User-Agent=${encodeURIComponent(`${navigator.userAgent}&`)}`,
      )
      //   const lines = linesArray.join('')
      // 去除最后一个&
      //   lines = lines.substring(0, lines.length - 3)
      //   lines = leftBrackets + lines + rightBrackets
      //   const url = String(getNewReportUrl(server, logName)) + lines
      // 去除enhanceLogger上报 -- 2024/05/13
      //   sendBeacon(url)
      return false
    },
  })
}
export default track
